import { render, staticRenderFns } from "./modelLoad.vue?vue&type=template&id=ff22c5a8&scoped=true&lang=pug"
import script from "./modelLoad.vue?vue&type=script&lang=js"
export * from "./modelLoad.vue?vue&type=script&lang=js"
import style0 from "./modelLoad.vue?vue&type=style&index=0&id=ff22c5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff22c5a8",
  null
  
)

export default component.exports